import { ColorValue } from 'react-native'

import { useNavigationState } from '@react-navigation/native'
import { useAddCustomerNextState } from '@zet/customer/src/api/hooks'
import useAddCustomerStore from '@zet/customer/src/store/addCustomer'
import { Icon, colors as zetColors } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'

import { useNavigation } from '../hooks/useNavigation'

type GoBackProps = {
  size?: number
  color?: ColorValue
  type?: string
  handleBack?: () => void
  isAddCustomerFlow?: boolean
  className?: string
  isDemoSale?: boolean
  style?: React.CSSProperties
}

export const GoBackButton = ({
  size,
  color,
  type = 'ArrowLeft',
  handleBack,
  isAddCustomerFlow,
  isDemoSale = false,
  ...props
}: GoBackProps) => {
  const screenName = useNavigationState(
    (state: any) => state.routes[state.routes.length - 1].name
  )
  const { customerId } = useAddCustomerStore((store) => store)
  const { mutate: experimentMutate } = useAddCustomerNextState()
  const { goBack, canGoBack, navigate } = useNavigation()

  const onPressBack = () => {
    if (isAddCustomerFlow) {
      experimentMutate({
        customerId: customerId,
        screenName: 'BACK',
        isDemoSale: isDemoSale,
      })
    } else if (canGoBack()) {
      if (handleBack) handleBack()
      else goBack()
    } else {
      navigate('HomeView')
    }
  }

  return (
    <Pressable onPress={onPressBack} opacity {...props}>
      <Icon
        type={type}
        size={size || 22}
        color={color || zetColors.neutral.white100}
      />
    </Pressable>
  )
}
